var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.40594 12.1353C5.06385 12.1353 4.77307 11.9878 4.5336 11.6927L1.21103 7.60045C1.11695 7.48927 1.04853 7.38023 1.00577 7.27333C0.967285 7.16642 0.948043 7.05524 0.948043 6.93979C0.948043 6.68322 1.03357 6.47155 1.20461 6.30478C1.37566 6.13801 1.5916 6.05462 1.85245 6.05462C2.14751 6.05462 2.39552 6.18077 2.5965 6.43306L5.38028 9.96089L10.8131 1.35298C10.9243 1.18194 11.0398 1.0622 11.1595 0.993785C11.2792 0.921091 11.4289 0.884743 11.6085 0.884743C11.8694 0.884743 12.0832 0.96599 12.2499 1.12848C12.4167 1.29098 12.5001 1.49837 12.5001 1.75067C12.5001 1.85329 12.483 1.95592 12.4488 2.05855C12.4146 2.16118 12.3611 2.26808 12.2884 2.37926L6.28469 11.6671C6.07943 11.9792 5.78652 12.1353 5.40594 12.1353Z","fill":"black"}));
}

Checkmark.defaultProps = {"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
